import { useLayoutEffect, useState } from 'react';
import { formatMessage } from '../../../../../translations/format-message';
import ImageContentView from './image-content-view';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import TaplerView from './image-content-types/tapler-csv-view';
import DimensionTableView from './image-content-types/dimension-table-view';
import CheckItemsView from './image-content-types/check-items-view';
import BOMView from './image-content-types/bom-data-view';
import { IProductFiles } from '../../../../../models/response/IProductResponse';

interface IProps {
  id: number;
  processFileDetails: any;
  processType: number;
  selectedProcess: number;
  selectedImage: IProductFiles[];
  selectedImageIndex: number;
}
enum imageDataType {
  tapler = 0,
  check_item = 1,
  dimension_table = 2,
  // bom = 3,
}

const ImageTabView = observer((props: IProps) => {
  const {
    selectedImage,
    selectedImageIndex,
    processFileDetails,
    processType,
    selectedProcess,
  } = props;
  const [imageDataTypeArray, setImageDataTypeArray] = useState<any[]>([]);
  const { values } = useFormikContext<any>();
  const [selectedContent, setSelectedContent] = useState<number>(
    imageDataTypeArray.length > 0 ? imageDataTypeArray[0].enumId : -1
  );
  const [activeTab, setActiveTab] = useState<string>(
    imageDataTypeArray.length > 0 ? imageDataTypeArray[0].enumName : ''
  );

  useLayoutEffect(() => {
    setImageDataTypeArray(() => []);
    if (processType == 2) {
      setImageDataTypeArray((prev) => [
        { enumId: imageDataType.tapler, enumName: 'tapler' },
      ]);
      // if (isDimensionTable) {
      //   setImageDataTypeArray((prev) => [
      //     ...prev,
      //     {
      //       enumId: imageDataType.dimension_table,
      //       enumName: 'dimension_table',
      //     },
      //   ]);
      // } else {
      setImageDataTypeArray((prev) => [
        ...prev.filter((item) => item.enumId !== imageDataType.dimension_table),
        { enumId: imageDataType.check_item, enumName: 'check_item' },
      ]);
      // }
    }
    // else if (processType == 3) {
    //   setImageDataTypeArray((prev) => [
    //     { enumId: imageDataType.bom, enumName: 'bom' },
    //   ]);
    //   // if (isDimensionTable) {
    //   //   setImageDataTypeArray((prev) => [
    //   //     ...prev,
    //   //     {
    //   //       enumId: imageDataType.dimension_table,
    //   //       enumName: 'dimension_table',
    //   //     },
    //   //   ]);
    //   // } else {
    //   setImageDataTypeArray((prev) => [
    //     ...prev.filter((item) => item.enumId !== imageDataType.dimension_table),
    //     { enumId: imageDataType.check_item, enumName: 'check_item' },
    //   ]);
    //   // }
    // }
    else {
      // if (isDimensionTable) {
      //   setImageDataTypeArray((prev) => [
      //     ...prev,
      //     {
      //       enumId: imageDataType.dimension_table,
      //       enumName: 'dimension_table',
      //     },
      //   ]);
      // } else {
      setImageDataTypeArray((prev) => [
        ...prev.filter((item) => item.enumId !== imageDataType.dimension_table),
        { enumId: imageDataType.check_item, enumName: 'check_item' },
      ]);
    }
    // }
  }, [processType, setImageDataTypeArray]);

  useLayoutEffect(() => {
    if (imageDataTypeArray.length > 0) {
      const activeTabName = imageDataTypeArray.find(
        (item) => item.enumId === selectedContent
      )?.enumName;
      setActiveTab(activeTabName || null);
    }
  }, [imageDataTypeArray, processType, selectedContent]);

  const renderTabView = () => {
    if (activeTab === 'tapler') {
      return (
        <TaplerView
          id={props.id}
          selectedImage={selectedImage}
          selectedImageIndex={selectedImageIndex}
        />
      );
    } else if (activeTab === 'dimension_table') {
      return (
        // <DimensionTableView
        //   selectedProcess={selectedProcess}
        //   id={props.id}
        //   selectedImage={selectedImage}
        //   selectedImageIndex={selectedImageIndex}
        // />
        <CheckItemsView
          id={props.id}
          selectedProcess={selectedProcess}
          selectedImage={selectedImage}
          selectedImageIndex={selectedImageIndex}
        />
      );
    } else if (activeTab === 'check_item') {
      return (
        <CheckItemsView
          id={props.id}
          selectedProcess={selectedProcess}
          selectedImage={selectedImage}
          selectedImageIndex={selectedImageIndex}
        />
      );
    } else if (activeTab === 'bom') {
      return <BOMView />;
    }
    return null;
  };

  useLayoutEffect(() => {
    setSelectedContent(
      imageDataTypeArray.length > 0 ? imageDataTypeArray[0].enumId : -1
    );
    setActiveTab(
      imageDataTypeArray.length > 0 ? imageDataTypeArray[0].enumName : ''
    );
  }, [imageDataTypeArray]);

  return (
    <div className="check-item-list checkItemsDimension check-item-step-4">
      <ul
        className="nav nav-tabs border-0"
        id="imageDataTypeTab"
        role="tablist"
      >
        {imageDataTypeArray.map((item) => (
          <li
            className={`nav-item ${selectedContent === item.enumId ? 'active' : ''}`}
            role="presentation"
            onClick={() => setSelectedContent(item.enumId)}
          >
            <button
              key={item.enumId}
              className={`nav-link ${selectedContent === item.enumId ? 'active' : ''}`}
              id={`imageDataType-${item.enumId}-tab`}
              // data-bs-toggle="tab"
              // data-bs-target={`#imageDataType-${item.enumId}`}
              type="button"
              role="tab"
              aria-controls={`imageDataType-${item.enumId}`}
              aria-selected={selectedContent === item.enumId ? 'true' : 'false'}
              onClick={() => setSelectedContent(item.enumId)}
            >
              {formatMessage(item.enumName)}
            </button>
          </li>
        ))}
      </ul>
      <div
        className="tab-content pb-0 border"
        id="imageDataTypeTabContent"
      >
        {renderTabView()}
      </div>
    </div>
  );
});

export default ImageTabView;
